import { produce } from "immer";
import {
  FETCH_APPOINTMENTS,
  FETCH_APPOINTMENTS_SUCCESS,
  FETCH_APPOINTMENTS_FAILURE,
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  ADD_APPOINTMENT,
  ADD_APPOINTMENT_SUCCESS,
  ADD_APPOINTMENT_FAILURE,
  EDIT_APPOINTMENT,
  EDIT_APPOINTMENT_SUCCESS,
  EDIT_APPOINTMENT_FAILURE,
  DELETE_APPOINTMENT,
  DELETE_APPOINTMENT_SUCCESS,
  DELETE_APPOINTMENT_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingAppointments: false,
  appointments: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentAppointment: {},
  // Delete
  isDeleting: false,
};

const ResidentAppointmentReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_APPOINTMENTS:
        draft.isFetchingAppointments = true;
        draft.appointments = [];
        break;
      case FETCH_APPOINTMENTS_SUCCESS:
        draft.isFetchingAppointments = false;
        draft.appointments = action.payload;
        break;
      case FETCH_APPOINTMENTS_FAILURE:
        draft.appointments = [];
        draft.isFetchingAppointments = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentAppointment = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentAppointment = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_APPOINTMENT:
        draft.isSubmitting = true;
        break;
      case ADD_APPOINTMENT_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_APPOINTMENT_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_APPOINTMENT:
        draft.isSubmitting = true;
        break;
      case EDIT_APPOINTMENT_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_APPOINTMENT_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_APPOINTMENT:
        draft.isDeleting = true;
        break;
      case DELETE_APPOINTMENT_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_APPOINTMENT_FAILURE:
        draft.isDeleting = false;
        break;

      default:
        return state;
    }
  });

export default ResidentAppointmentReducer;
